import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import Api from "../../Hooks/Api";
import useDelete from "../../Hooks/useDelete";
import useFetch from "../../Hooks/useFetch";
import useSave from "../../Hooks/useSave";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";

const SecurityGroups = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [view, setview] = useState(false);
  const [update, setUpdate] = useState(false);
  const [showRolesPoup, setshowRolesPoup] = useState(false);
  const [PageRole, setPageRole] = useState("Security Groups");
  const [Roles, setRoles] = useState([]);

  const url = "api/securityGroups/";
  const { state, FetchAll } = useFetch(url + "getAll");
  useEffect(() => {
    FetchAll();
  }, []);
  const Fetchroles = (id) => {
    Api.get("api/securityGroupPermissions/getBySecurityGroup?groupId=" + id)
      .then(function (response) {
        setRoles(response.data);
      })
      .catch(function (error) {})
      .then(function () {
        // always executed
      });
  };
  const handleOpenModal = (event) => {
    //event.persist();
    setInputs({});
    setOpen(true);
  };
  const handleShowRolesPoup = () => {
    setOpen(false);
    setUpdate(false);
    setshowRolesPoup(true);
  };
  const closeRolesPoup = () => {
    setUpdate(false);
    setshowRolesPoup(false);
  };
  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
  };

  const handleEdit = (k) => {
    setInputs(k);
    Fetchroles(k.securityGroupId);
    if (k.securityGroupId) {
      setOpen(true);
      setUpdate(true);
      setview(false);
    } else {
      alert("Select a record to edit");
    }
  };
  const handleView = (k) => {
    Fetchroles(k.securityGroupId);
    setInputs(k);
    if (k.securityGroupId) {
      setview(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to veiw");
    }
  };

  const handleCloseModal = () => {
    setInputs({});
    setOpen(false);
    setview(false);
    setUpdate(false);
    setshowRolesPoup(false);
  };
  const HandleSave = () => {
    useSave(url + "create", inputs);
    setTimeout(() => {
      FetchAll();
    }, 5000);
  };
  const HandleUpdate = () => {
    useUpdate(url + "update", inputs);
    setTimeout(() => {
      FetchAll();
    }, 5000);
  };
  const HandleSubmit = (event) => {
    event.preventDefault();
    if (update) {
      HandleUpdate();
    } else {
      HandleSave();
    }
  };
  const CallDeletehook = () => {
    useDelete(url + "delete?securityGroupId=" + inputs.securityGroupId);
    setTimeout(() => {
      FetchAll();
    }, 5000);
  };
  const MoreActions = (props) => {
    return (
      <span>
        <a
          class="btn btn-secondary btn-sm dropdown-toggle"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          More Actions&nbsp;&nbsp;
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleView(props.selecteditem, e)}
          >
            View
          </a>

          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleEdit(props.selecteditem, e)}
          >
            Edit
          </a>

          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => HandleDelete(props.selecteditem, e)}
          >
            Delete
          </a>
        </div>
      </span>
    );
  };
  const HandleDelete = (k) => {
    setInputs(k);
    if (k.securityGroupId) {
      CallDeletehook();
    } else {
      alert("Select a record to delete");
    }
  };
  const ColumnData = [
    {
      label: "Name",
      field: "name",
      sort: "asc",
    },
    {
      label: "Actions",
      field: "Actions",
      sort: "asc",
    },
  ];
  let Rowdata1 = [];
  const rows = state.data;
  if (rows.length > 0) {
    rows.forEach((k) => {
      const Rowdata = {
        Actions: <MoreActions selecteditem={k} />,
        name: k.name,
      };
      Rowdata1.push(Rowdata);
    });
  }
  const HandleRolesUpdate = (puturl, data = {}) => {
    useUpdate(puturl, data);
  };
  const handleCheckBoxChange = (Role, e) => {
    const target = e.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    if (name == "Create") {
      let data = {
        permissionId: Role.permissionId,
        securityGroupId: inputs.securityGroupId,
        addRecord: value === true ? 1 : 0,
        exportRecord: Role.exportRecord,
        deleteRecord: Role.deleteRecord,
        viewRecord: Role.viewRecord,
        editRecord: Role.editRecord,
      };
      HandleRolesUpdate(
        "api/securityGroupPermissions/create?menu=Create",
        data
      );
    } else if (name == "View") {
      let data = {
        permissionId: Role.permissionId,
        securityGroupId: inputs.securityGroupId,
        addRecord: Role.addRecord,
        exportRecord: Role.exportRecord,
        deleteRecord: Role.deleteRecord,
        viewRecord: value === true ? 1 : 0,
        editRecord: Role.editRecord,
      };
      HandleRolesUpdate("api/securityGroupPermissions/create?menu=View", data);
    } else if (name == "Delete") {
      let data = {
        permissionId: Role.permissionId,
        securityGroupId: inputs.securityGroupId,
        addRecord: Role.addRecord,
        exportRecord: Role.exportRecord,
        deleteRecord: value === true ? 1 : 0,
        viewRecord: Role.viewRecord,
        editRecord: Role.editRecord,
      };
      HandleRolesUpdate(
        "api/securityGroupPermissions/create?menu=Delete",
        data
      );
    } else if (name == "Update") {
      let data = {
        permissionId: Role.permissionId,
        securityGroupId: inputs.securityGroupId,
        addRecord: Role.addRecord,
        exportRecord: Role.exportRecord,
        deleteRecord: Role.deleteRecord,
        viewRecord: Role.viewRecord,
        editRecord: value === true ? 1 : 0,
      };
      HandleRolesUpdate(
        "api/securityGroupPermissions/create?menu=Update",
        data
      );
    } else if (name == "Export") {
      let data = {
        permissionId: Role.permissionId,
        securityGroupId: inputs.securityGroupId,
        addRecord: Role.addRecord,
        exportRecord: value === true ? 1 : 0,
        deleteRecord: Role.deleteRecord,
        viewRecord: Role.viewRecord,
        editRecord: Role.editRecord,
      };
      HandleRolesUpdate(
        "api/securityGroupPermissions/create?menu=Export",
        data
      );
    }
  };
  const RolesPoup = () => {
    let tablestyle = {
      width: "60%",
    };
    //let Menus = [Roles.response];

    let Menus = [];
    let Approval = [];
    let UserManagement = [];
    let Configurations = [];
    let MOUs = [];
    let TourismSafety = [];
    let Investments = [];
    let Reports = [];
    let TourismProducts = [];
    let PolicyAndResearch = [];
    let TourismActivities = [];
    let VettingExpartriates = [];
    let Marketing = [];
    let Monitoring = [];
    if (Roles.length > 0) {
      let MenusCategory = Roles.filter(
        (option) => option.permission.category === "Menus"
      );
      let TourismSafetyCategory = Roles.filter(
        (option) => option.permission.category === "TourismSafety"
      );
      let PolicyAndResearchCategory = Roles.filter(
        (option) => option.permission.category === "PolicyAndResearch"
      );
      let MonitoringCategory = Roles.filter(
        (option) => option.permission.category === "Monitoring"
      );
      let InvestmentsCategory = Roles.filter(
        (option) => option.permission.category === "Investments"
      );
      let MarketingCategory = Roles.filter(
        (option) => option.permission.category === "Marketing"
      );
      let VettingExpartriatesCategory = Roles.filter(
        (option) => option.permission.category === "VettingExpartriates"
      );
      let TourismActivitiesCategory = Roles.filter(
        (option) => option.permission.category === "TourismActivities"
      );
      let UserManagementCategory = Roles.filter(
        (option) => option.permission.category === "User Management"
      );
      let TourismProductsCategory = Roles.filter(
        (option) => option.permission.category === "TourismProducts"
      );
      let ApprovalCategory = Roles.filter(
        (option) => option.permission.category === "Approval"
      );
      if (ApprovalCategory.length > 0) {
        Approval.push(ApprovalCategory);
      }
      if (PolicyAndResearchCategory.length > 0) {
        PolicyAndResearch.push(PolicyAndResearchCategory);
      }
      let ConfigurationsCategory = Roles.filter(
        (option) => option.permission.category === "Configurations"
      );
      let MOUsCategory = Roles.filter(
        (option) => option.permission.category === "MOUs"
      );
      let ReportsCategory = Roles.filter(
        (option) => option.permission.category === "Reports"
      );
      if (ReportsCategory.length > 0) {
        Reports.push(ReportsCategory);
      }
      if (MarketingCategory.length > 0) {
        Marketing.push(MarketingCategory);
      }
      if (MOUsCategory.length > 0) {
        MOUs.push(MOUsCategory);
      }
      if (InvestmentsCategory.length > 0) {
        Investments.push(InvestmentsCategory);
      }
      if (MonitoringCategory.length > 0) {
        Monitoring.push(MonitoringCategory);
      }

      if (TourismProductsCategory.length > 0) {
        TourismProducts.push(TourismProductsCategory);
      }
      if (TourismActivitiesCategory.length > 0) {
        TourismActivities.push(TourismActivitiesCategory);
      }
      if (TourismSafetyCategory.length > 0) {
        TourismSafety.push(TourismSafetyCategory);
      }
      if (VettingExpartriatesCategory.length > 0) {
        VettingExpartriates.push(VettingExpartriatesCategory);
      }
      if (UserManagementCategory.length > 0) {
        UserManagement.push(UserManagementCategory);
      }
      if (MenusCategory.length > 0) {
        Menus.push(MenusCategory);
      }
      if (ConfigurationsCategory.length > 0) {
        Configurations.push(ConfigurationsCategory);
      }
    }

    return (
      <Modal visible={showRolesPoup} width="70%" height="90%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={closeRolesPoup}>
            &times;
          </a>
          <div className="text-center">
            <b>{inputs.name}</b>{" "}
          </div>

          <form>
            <table className="table">
              <thead className="table-success">
                <th scope="col" style={tablestyle}>
                  Role
                </th>
                <th>Create</th>
                <th>View</th>
                <th>Delete</th>
                <th>Update</th>
                <th>Export</th>
              </thead>
              {Menus.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Menus
                  </h5>
                  {Menus[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {UserManagement.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    User Management
                  </h5>
                  {UserManagement[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Approval.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Approval
                  </h5>
                  {Approval[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {VettingExpartriates.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Vetting Expartriates
                  </h5>
                  {VettingExpartriates[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {TourismSafety.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Tourism Safety
                  </h5>
                  {TourismSafety[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {TourismActivities.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Tourism Activities
                  </h5>
                  {TourismActivities[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Configurations.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Configurations
                  </h5>
                  {Configurations[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Monitoring.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Monitoring
                  </h5>
                  {Monitoring[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Marketing.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Marketing
                  </h5>
                  {Marketing[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Investments.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Investments
                  </h5>
                  {Investments[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {PolicyAndResearch.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Policy And Research
                  </h5>
                  {PolicyAndResearch[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {MOUs.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    MOUs
                  </h5>
                  {MOUs[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}

              {TourismProducts.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Tourism Products
                  </h5>
                  {TourismProducts[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
              {Reports.length > 0 ? (
                <tbody style={{ marginLeft: "30px" }}>
                  <h5 style={{ marginLeft: "10px" }} className="text-blue">
                    Reports
                  </h5>
                  {Reports[0].map((role, i) => {
                    return (
                      <tr id={i}>
                        <td>{role.permission.name}</td>
                        <td>
                          <input
                            className="checkbox"
                            id={i}
                            type="checkbox"
                            name="Create"
                            defaultChecked={role.addRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 1}
                            type="checkbox"
                            name="View"
                            defaultChecked={role.viewRecord}
                            //   value=""
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 2}
                            type="checkbox"
                            name="Delete"
                            defaultChecked={role.deleteRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Update"
                            defaultChecked={role.editRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                        <td>
                          <input
                            className="checkbox"
                            id={i + 3}
                            type="checkbox"
                            name="Export"
                            defaultChecked={role.exportRecord}
                            onChange={(e) => handleCheckBoxChange(role, e)}
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : null}
            </table>

            <br />
            <div style={{ display: "flex", "justify-content": "flex-end" }}>
              <div class="d-flex flex-row ">
                <button
                  className="btn btn-primary p-2 float-right"
                  type="button"
                  onClick={closeRolesPoup}
                >
                  Done
                </button>
                &nbsp;
                <button
                  className="btn btn-warning p-2"
                  type="button"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
            <br />
          </form>
        </div>
      </Modal>
    );
  };
  const ActionsBtn = () => {
    return (
      <div>
        {/* {useValidateRole(PageRole, "Edit") ? (
          <button
            className="btn btn-primary p-2"
            type="button"
            onClick={handleEdit}
          >
            Update
          </button>
        ) : null}
        &nbsp; */}
        {useValidateRole("Security Group Roles", "AddNew") ? (
          <button
            className="btn btn-info p-2"
            type="button"
            onClick={handleShowRolesPoup}
          >
            Roles
          </button>
        ) : null}
        &nbsp;
        {useValidateRole(PageRole, "Remove") ? (
          <button onClick={HandleDelete} className="btn btn-danger p-2">
            Delete
          </button>
        ) : null}
        &nbsp;
        <button
          className="btn btn-warning p-2"
          type="button"
          onClick={handleCloseModal}
        >
          Close
        </button>
      </div>
    );
  };
  return (
    <div id="content" className="content">
      <ol class="breadcrumb float-xl-right">
        <li class="breadcrumb-item">
          {" "}
          <Link to="/">Home </Link>{" "}
        </li>
        <li class="breadcrumb-item active">SecurityGroups</li>
      </ol>
      <h1 class="page-header mb-3">Security Groups</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div class="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            {useValidateRole(PageRole, "AddNew") ? (
              <button
                onClick={handleOpenModal}
                className="btn btn-primary p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; New security group &nbsp;
              </button>
            ) : null}
            {/* {useValidateRole(PageRole, "View") ? (
              <button
                onClick={handleView}
                className="btn btn-success p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; View &nbsp;
              </button>
            ) : null}
            {useValidateRole(PageRole, "Edit") ? (
              <button
                onClick={handleEdit}
                className="btn btn-info p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; Edit &nbsp;
              </button>
            ) : null}
            {useValidateRole(PageRole, "Remove") ? (
              <button
                onClick={HandelDelete}
                className="btn btn-danger p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; Delete &nbsp;
              </button>
            ) : null} */}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={Rowdata1} columns={ColumnData} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="40%" height="30%" effect="fadeInUp">
        <div style={{ "overflow-y": "auto", height: "100%" }}>
          <a className="close" onClick={() => handleCloseModal()}>
            &times;
          </a>

          <div className="row">
            <div className="col-sm-5"></div>
            {view ? null : (
              <div className="col-sm-4 fontWeight-bold text-blue">
                Security Group
              </div>
            )}
          </div>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />

                {view ? (
                  <div>
                    <h3>Security Group</h3>
                    <table className="table table-sm">
                      <tbody>
                        <tr>
                          <td className="font-weight-bold">Name:</td>
                          <td>{inputs.name}</td>
                        </tr>
                      </tbody>
                    </table>
                    <br />
                    <div
                      style={{ display: "flex", "justify-content": "flex-end" }}
                    >
                      <ActionsBtn />
                    </div>
                    <br />
                  </div>
                ) : (
                  <form className="form-horizontal" onSubmit={HandleSubmit}>
                    <div className=" row">
                      <div className="col-sm">
                        <div className="form-group">
                          <label
                            htmlFor="Datereceived"
                            className="fontWeight-bold"
                          >
                            Description
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            required
                            value={inputs.name}
                            onChange={handleInputChange}
                            // defaultvalue={inputs.name}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ display: "flex", "justify-content": "flex-end" }}
                    >
                      <div class="d-flex flex-row">
                        {update ? (
                          <button className="btn btn-primary p-2" type="submit">
                            Update
                          </button>
                        ) : (
                          <button className="btn btn-primary p-2" type="submit">
                            Submit
                          </button>
                        )}
                        &nbsp;
                        <button
                          className="btn btn-warning p-2"
                          type="button"
                          onClick={handleCloseModal}
                        >
                          Close
                        </button>
                      </div>
                      <br />
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <RolesPoup />
    </div>
  );
};
export default SecurityGroups;
